<!--
 * @Descripttion:
 * @Author: liang
 * @Date: 2021-05-10 16:57:24
 * @LastEditors: liang
 * @LastEditTime: 2021-09-10 10:49:26
-->
<template>
  <div style="padding:0 20px">
    <h1 class="perText1">我的考试汇总</h1>
    <div style="padding-top:40px">
      <div class="topinfo">
        <!-- <el-card>
          <h3>今年总分</h3>
          <div class="count"><b>{{topinfo.yearScore}}</b>分</div>
        </el-card> -->
        <el-card>
          <h3>今年参加考试</h3>
          <div class="count"><b>{{topinfo.examTimes}}</b>次</div>
        </el-card>
        <el-card>
          <h3>今年通过考试</h3>
          <div class="count"><b>{{topinfo.passTimes}}</b>次</div>
        </el-card>
      </div>
      <h1 class="perText1">我的考试记录</h1>
      <el-table
        :data="dataList"
        style="width: 100%;margin-top: 20px;"
        border>
        <el-table-column type="index" header-align="center" align="center" width="60" label="序号"></el-table-column>
        <el-table-column prop="examPaperName" label="考试名称" align="center"></el-table-column>
        <el-table-column prop="year" label="年度" align="center"></el-table-column>
        <el-table-column prop="points" label="考试得分" align="center">
          <template slot-scope="scope">
            {{scope.row.points}}分
          </template>
        </el-table-column>
        <el-table-column prop="isPass" label="是否通过" align="center">
          <template slot-scope="scope">
            {{scope.row.isPass==0?'不通过':'通过'}}
          </template>
        </el-table-column>
        <el-table-column prop="startDate" label="考试时间" align="center"></el-table-column>
      </el-table>
      <div style="text-align:right;margin-top:20px;">
        <el-pagination
          :current-page="page"
          background
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next"
          @size-change="pageSizeChange"
          @current-change="pageCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from '@/mixins/index'
export default {
  mixins: [mixins],
  name: 'personal',
  data () {
    return {
      topinfo: {},
      dataList: [],
      page: 1, // 当前页码
      limit: 10, // 每页数
      total: 0 // 总条数
    }
  },
  methods: {
    init () {
      this.getInfo()
      this.getList()
    },
    getInfo () {
      this.$get('/exam/etuserexamhistory/getUserDetails').then(res => {
        if (res.code === 0) {
          this.topinfo = res.data
        }
      })
    },
    getList () {
      let params = { type: '1', page: this.page, limit: this.limit }
      this.$get('/exam/etuserexamhistory/page', params).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.list
          this.total = res.data.total
        }
      })
    },
    // 分页, 每页条数
    pageSizeChange (val) {
      this.page = 1
      this.limit = val
      this.getList()
    },
    // 分页, 当前页
    pageCurrentChange (val) {
      this.page = val
      this.getList()
    }
  }
}
</script>
<style scoped>
  .perText1{
    font-size: 22px;
  }
  .topinfo{display: flex;margin-bottom: 15px;}
  .topinfo .el-card {flex: 1;height: 130px;overflow: hidden;text-align: center;}
  .topinfo .el-card:nth-child(2){margin: 0 10px;}
  .topinfo h3{font-weight: normal;font-size: 18px;padding: 10px 0}
  .topinfo .count b{font-size: 28px;font-weight: normal;padding-right: 3px;}
  .progress{border: 1px solid #ddd;padding:10px;}
</style>
